import "@shopify/polaris/build/esm/styles.css";
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import { onLCP, onCLS } from 'web-vitals';

onLCP(lcp => {
    console.log('LCP seconds:', lcp.value / 1000);
    console.log('LCP details:', lcp.entries);
}, { reportAllChanges: true });

onCLS(cls => {
    console.log('CLS score:', cls.value);
    console.log('CLS details:', cls.entries);
}, { reportAllChanges: true });

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(<App />);

//registerServiceWorker();